<template>
  <div>
    <footer>
      <div class="container">
        <hr class="mb-4">
        <div class="row">
          <div class="col-lg-7 offset-lg-1">
            <div class="row">
              <div class="col-md-3 col-6">
                <h3>Empresa</h3>
                <ul>
                  <li>
                    <router-link to="/sobre">
                      <a>Quem Somos</a>
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/contato">
                      <a>Contato</a>
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/eventos">
                      <a>Eventos</a>
                    </router-link>
                  </li>
                  <!--<li>
                    <router-link to="/">
                      <a>Vídeos</a>
                    </router-link>
                  </li>-->
                </ul>
              </div>
              <div class="col-md-3 col-6">
                <h3>Serviços</h3>
                <ul>
                  <li>

                      <a href="https://static.japanparts.com.br/Japanparts-2017-2018.zip">Catálogo</a>

                  </li>
                  <li>
                    <router-link to="/produtos">
                      <a>Produtos</a>
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/lancamentos">
                      <a>Lançamentos</a>
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/dicas">
                      <a>Dicas Técnicas</a>
                    </router-link>
                  </li>
                </ul>
              </div>
              <div class="col-md-3 text-center">
                <hr class="d-block d-md-none mb-4 mt-4">
                <h3>Nos Siga</h3>
                <ul>
                  <li>
                    <a href="https://www.facebook.com/FastLubeOficialJapanparts/" target="_blank">
                      <i class="icon-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.instagram.com/fastlubejapanparts/" target="_blank">
                      <i class="icon-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.youtube.com/fastlubefiltrosautomotivosjapanparts" target="_blank">
                      <i class="icon-youtube"></i>
                    </a>
                  </li>
                </ul>
              </div>
              <div class="col-md-3 d-none d-md-block">
                <img src="../../static/images/fast-lube-logo.png" alt="Fast Lube">
              </div>
            </div>
          </div>
          <div class="col-lg-4 order-lg-first text-center text-lg-left">
            <hr class="d-block d-lg-none mb-4 mt-4">
            <h3>Contato</h3>
            <div class="mb-1">Av Dr. Mauro Lindemberg Monteiro 185 – GP 8</div>
            <div class="mb-4">Jd Santa Fé / Osasco, SP - CEP 06278-010</div>
            <div>Email: contato@japanparts.com.br Telefone: (11) 3670-4400</div>
          </div>
        </div>
        <div class="d-md-none row mt-5 text-center">
          <div class="col-4 offset-4">
            <img src="../../static/images/fast-lube-logo.png" alt="Fast Lube">
          </div>
        </div>
      </div>
    </footer>
    <section class="copy text-center text-lg-left">
      <div class="container">
        <div>Fast Lube - Todos os direitos reservados / Desenvolvido por EspressoLabs</div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Footer",
  mounted() {},
  data() {
    return {};
  },
  computed: {},
  methods: {}
};
</script>

<style lang="scss">
</style>





// WEBPACK FOOTER //
// src/components/Footer.vue